export const toTitleCase = (str) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add a space before each uppercase letter
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
};

export const NAV_ITEMS = {
  HOME: 'Home',
  HOW_TO_USE: 'How to Use',
  SUMMARY: 'Summary'
};

export const SECTIONS = {
  PRODUCT_USER_KIT: "Products in User Kit",
  ALL_PRODUCTS: "All Products",
  COMBINED_USAGE: "Combined Usage",
  GENERAL_QUERIES: "General Queries",
};

export function createVariantIdMapForProductRead(data) {
  const map = {};

  function traverse(items) {
    for (const item of items) {
      if (item.variantId && !map[item.variantId]) {
        map[item.variantId] = item.product_read || null;
      }
      if (item.sub && item.sub.length > 0) {
        traverse(item.sub);
      }
    }
  }

  traverse(data);
  return map;
}